<template>
  <el-dialog class="pv-image-dialog" :visible.sync="data.visible" :title="title"
             width="800px"
             center>
    <div>
      <div class="pv-content">
        <img :src="data.src" oncontextmenu="return false;"/>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: '',
    data: {
      visible: false,
      src: ''
    }
  }
}
</script>

<style>
.v-modal {
  opacity: 0.9;
}
.pv-image-dialog .el-dialog {
  background: #0C0C0C;
}

.pv-image-dialog .el-dialog__header {
  padding: 0 20px 0px 20px;
  height: 50px;
  background-color: #16161A;
}

.pv-image-dialog .el-dialog__title {
  color: rgba(255, 255, 255, 0.8);
  line-height: 50px;
}

.pv-image-dialog .el-dialog__body {
  padding: 0;
}

.pv-image-dialog .pv-content {
  padding-top: 5px;
  width: 800px;
  min-height: 450px;
  margin-left: auto;
  margin-right: auto;
}

.pv-image-dialog .pv-content img {
  width: 800px;
  min-height: 500px;
  max-height: 600px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/PreviewImageDialog.vue